// Copyright (c) 2017 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PipCellRenderer from '../../shared/report-cell-renderers/pip-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getOpenPipsColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerAccount',
            field: 'responsibleAccount.account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'leadAccount',
            field: 'leadAccount.account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LEAD_ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PipCellRenderer,
            colId: 'pipNumber',
            field: 'pipNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIP_NUMBER'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PipCellRenderer,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 250
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'pipType',
            field: 'pipType.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIP_TYPE'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'pipStatus',
            field: 'pipStatus.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIP_STATUS'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'statusReason',
            field: 'statusReason',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATUS_REASON'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'startDate',
            field: 'startDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('STARTS'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'expireDate',
            field: 'expireDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('EXPIRES'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'terminationDate',
            field: 'terminationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('TERMINATES'),
            width: 120
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'daysRemaining',
            field: 'daysRemaining',
            headerClass: classNames.headerRightClassName,
            headerName: translate('DAYS_REMAINING'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: PipCellRenderer,
            colId: 'totalPins',
            field: 'totalPins',
            headerClass: classNames.headerRightClassName,
            headerName: translate('TOTAL'),
            width: 180
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'completedPins',
            field: 'completedPins',
            headerClass: classNames.headerRightClassName,
            headerName: translate('COMPLETED'),
            width: 180
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'completionPercent',
            field: 'completionPercent',
            headerClass: classNames.headerRightClassName,
            headerName: translate('PERCENT_COMPLETE'),
            width: 200
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'gracePeriodPins',
            field: 'gracePeriodPins',
            headerClass: classNames.headerRightClassName,
            headerName: translate('GRACE_PERIOD'),
            width: 175
        },

        {
            cellClass: classNames.cellLeftClassName,
            colId: 'participant',
            field: 'participant.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PARTICIPANT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'metric',
            field: 'metric.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('METRIC'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'comments',
            field: 'comments',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COMMENTS'),
            width: 550
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/report-services/column-definitions.js